import { useLanguage } from "@/context/LanguageContext";

// Premium-automotive moment: a marquee strip of brands the workshop services.
// Honest claim — owner confirmed in their Maps reply that they "work on all cars".
const BRANDS = [
  "Mercedes-Benz",
  "BMW",
  "Audi",
  "Porsche",
  "Lexus",
  "Range Rover",
  "Cadillac",
  "Infiniti",
  "Toyota",
  "Nissan",
  "Ford",
  "Chevrolet",
  "Tesla",
  "Genesis",
  "Hyundai",
  "Honda",
];

const BrandsMarquee = () => {
  const { t } = useLanguage();
  // Triple the list so the loop never shows a gap during translation.
  const loop = [...BRANDS, ...BRANDS, ...BRANDS];

  return (
    <section
      className="relative border-b border-white/10 bg-[#0a0a0a] py-10 md:py-12 overflow-hidden"
      data-testid="brands-marquee"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-5 flex items-center gap-3">
        <span className="w-1.5 h-1.5 rounded-full bg-[#e10600] shadow-[0_0_10px_#e10600]" />
        <span className="text-[10px] tracking-[0.3em] uppercase font-display font-bold text-white/50">
          {t.brands.label}
        </span>
        <span className="flex-1 h-px bg-gradient-to-r from-white/10 via-white/5 to-transparent" />
      </div>

      <div className="relative">
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 start-0 w-24 bg-gradient-to-e from-[#0a0a0a] to-transparent z-[2]" />
        <div className="pointer-events-none absolute inset-y-0 end-0 w-24 bg-gradient-to-w from-[#0a0a0a] to-transparent z-[2]" />

        <div className="dx-marquee flex gap-12 md:gap-16">
          {loop.map((brand, i) => (
            <span
              key={`${brand}-${i}`}
              className="font-display font-bold text-2xl md:text-3xl tracking-tight text-white/35 hover:text-white transition-colors whitespace-nowrap"
              data-testid={`brand-${i}`}
            >
              {brand}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsMarquee;
